import HomePage from './Home.container';

export default HomePage;
